import { render, staticRenderFns } from "./LatestConversationBlock.vue?vue&type=template&id=e19ad522"
import script from "./LatestConversationBlock.vue?vue&type=script&lang=js"
export * from "./LatestConversationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports